import { ChartOption, ChartType, ReportResult } from "../entities/reportEntity";
import { isEmpty } from "@/utils/Common";

export default function (definition: any, chartOption: ChartOption, datas: ReportResult) {
  const xAxisData: Array<string> = [];
  for (let i = 0; i < datas.rowCount; i++) {
    if (datas.rowDimNodes[i][0].total) {
      continue;
    }
    if (xAxisData.indexOf(datas.rowDimNodes[i][0].label) < 0) {
      xAxisData.push(datas.rowDimNodes[i][0].label);
    }
  }
  const xAxis: any = {
    type: "category",
    data: xAxisData
  };

  if (!definition.rowDims[0].dateUnit) {
    xAxis.axisLabel = {
      rotate: 30
    };
  }

  const yAxis: any = {
    type: "value"
  };

  if (!chartOption.hideAxisTitle) {
    if (!isEmpty(chartOption.xaxisTitle)) {
      xAxis.name = chartOption.xaxisTitle;
    }
    if (!isEmpty(chartOption.yaxisTitle)) {
      yAxis.name = chartOption.yaxisTitle;
    }
  }

  const legendData: Array<string> = [];
  for (let i = 0; i < datas.rowDimNodes.length; i++) {
    if (!datas.rowDimNodes[i][1] || datas.rowDimNodes[i][1].total) {
      continue;
    }
    if (legendData.indexOf(datas.rowDimNodes[i][1].label) < 0) {
      legendData.push(datas.rowDimNodes[i][1].label);
    }
    legendData.sort();
  }

  const seriesValueMap: { [key: string]: number } = {};
  for (let i = 0; i < datas.rowDimNodes.length; i++) {
    if (!datas.rowDimNodes[i][1] || datas.rowDimNodes[i][1].total) {
      continue;
    }
    let count = 0;
    if (datas.dataValues[datas.rowColIndexes[i][0]]) {
      count = datas.dataValues[datas.rowColIndexes[i][0]][0];
    }
    seriesValueMap[datas.rowDimNodes[i][0].label + "#" + datas.rowDimNodes[i][1].label] = count;
  }

  const seriesMap: { [key: string]: Array<number> } = {};
  for (let i = 0; i < legendData.length; i++) {
    const label = legendData[i];
    seriesMap[label] = [];

    for (let j = 0; j < xAxisData.length; j++) {
      seriesMap[label].push(seriesValueMap[xAxisData[j] + "#" + label] || 0);
    }
  }

  const series = [];
  for (const label in seriesMap) {
    let seriesLabel: any = {};
    if (!chartOption.hideLabel) {
      seriesLabel = {
        normal: {
          show: true,
          position: "top"
        }
      };
    }

    series.push({
      name: label,
      type: chartOption.chartType == ChartType.BAR ? "bar" : "line",
      stack: "0",
      label: seriesLabel,
      data: seriesMap[label]
    });
  }

  const option: any = {
    tooltip: {
      trigger: "axis"
    },
    xAxis: xAxis,
    yAxis: yAxis,
    grid: {
      top: "24%",
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },
    series: series
  };

  if (!chartOption.hideLegend) {
    option.legend = {
      type: "scroll",
      y: "12%",
      data: legendData
    };
  }

  if (!chartOption.hideTitle && !isEmpty(chartOption.title)) {
    option.title = {
      left: "center",
      text: chartOption.title
    };
    if (!isEmpty(chartOption.subTitle)) {
      option.title.subtext = chartOption.subTitle;
    }
  }

  if (!chartOption.hideToolbox) {
    option.enableSwitchXY = true;
    option.toolbox = {
      show: true,
      feature: {
        magicType: { type: ["line", "bar"] },
        saveAsImage: {}
      }
    };
  }

  return option;
}
;
